var _path, _line, _line2, _path2, _path3, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Document50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8ce7f2",
    d: "M33.2,10H17c-1.7,0-3,1.3-3,3v31c0,1.7,1.3,3,3,3h23c1.7,0,3-1.3,3-3V19.8c0-0.5-0.2-1-0.6-1.4l-7.8-7.8 C34.2,10.2,33.7,10,33.2,10z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    x2: 30.5,
    y1: 22.5,
    y2: 22.5,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    x2: 26.5,
    y1: 29.5,
    y2: 29.5,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M22.1,42.5h13.4c1.7,0,3-1.3,3-3v-25h-7c-1.1,0-2-0.9-2-2v-7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M24,5.5H12.5c-1.7,0-3,1.3-3,3v31c0,1.7,1.3,3,3,3h3.9"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    x2: 29.5,
    y1: 14.5,
    y2: 5.5,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Document50);
export default __webpack_public_path__ + "static/media/icons8-document-50.48c5a245cb6667356831cf54cda83e6b.svg";
export { ForwardRef as ReactComponent };